module.exports = __webpack_public_path__ + "static/purplecareLogo-edafbdd4859232aa3f5d47fb3f78c8b7.png";